import { ICountry } from '../models/country-model';
import CountryMapper from '../mappings/country-mapper';
import { Config } from '../models/config-viewmodel';

class CountryService {
    private countryMapper = new CountryMapper();

    constructor() {}

    public getCountries = (config: Config, HttpService: any) => {
        return this.getCountryData(this.getCountriesQuery(config), HttpService);
    }

    private getCountryData = (url: string, HttpService: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            HttpService.getList(url).then((result: ICountry[]) => {
                resolve(this.countryMapper.mapCountries(result));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getCountriesQuery = (config: Config): string => {
        return `/api/formdata/${config.language}/countries`;
    }
}

export default new CountryService();